/* template */
<template><page><base-container><div :class='["btn-item"]'><cube-basic-picker/></div><div :class='["btn-item"]'><cube-wx-model-picker/></div><div :class='["btn-item"]'><cube-slot-picker/></div><div :class='["btn-item"]'><cube-update-data-picker/></div></base-container></page></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"_bb04f458"}'>
.btn-item
  margin-bottom 15px
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_bb04f458"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_bb04f458"}
  /** script content **/
  require("./index.mpx.js?isPage!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=page&index=0&isPage&lang=js&mpx&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_bb04f458"],
    ctorType: "page",
    outputPath: "",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'base-container':getComponent(require("../../components/base-container/index.mpx?isComponent&outputPath=components%2Findexa53ae8d2%2Findex")),'cube-basic-picker':getComponent(require("./basic-picker.mpx?isComponent&outputPath=components%2Fbasic-picker269412b9%2Findex")),'cube-wx-model-picker':getComponent(require("./wx-model-picker.mpx?isComponent&outputPath=components%2Fwx-model-picker22fefc60%2Findex")),'cube-slot-picker':getComponent(require("./slot-picker.mpx?isComponent&outputPath=components%2Fslot-picker94fab302%2Findex")),'cube-update-data-picker':getComponent(require("./update-data-picker.mpx?isComponent&outputPath=components%2Fupdate-data-picker8f020e0e%2Findex")),'cube-divider':getComponent(require("../../../packages/mpx-cube-ui/src/components/divider/index.mpx?isComponent&outputPath=components%2Findex731ea706%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>